(() => {
    function registerProductCard() {
        Alpine.data('productCard', () => ({
            adding: false,
            quantity: 1,
            minQuantity: 1,
            maxQuantity: 999999,
            productId: null,
            hasGallery: false,

            imageUrls: [],
            preloadedImages: [],
            imagesLoaded: false,
            imagesLoading: false,
            currentImageIndex: 0,
            slideshowInterval: null,
            isHovering: false,
            delay: 1000,

            init() {
                this.productId = parseInt(this.$el.dataset.productId);

                let minQty = parseInt(this.$el.dataset.minQuantity);
                let maxQty = parseInt(this.$el.dataset.maxQuantity);

                this.minQuantity = minQty > 0 ? minQty : 1;
                this.maxQuantity = maxQty > 0 ? maxQty : 999999;

                if (this.maxQuantity < this.minQuantity) {
                    this.maxQuantity = this.minQuantity;
                }
                this.quantity = this.minQuantity;

                this.hasGallery = this.$el.dataset.hasGallery === 'true';

                // Galéria képek URL-jeinek betöltése a data attribútumokból
                if (this.hasGallery) {
                    this.loadImageUrls();
                }
            },

            loadImageUrls() {
                const imagesCount = parseInt(this.$el.dataset.imagesCount) || 0;
                this.imageUrls = [];

                for (let i = 0; i < imagesCount; i++) {
                    const imageUrl = this.$el.dataset[`image-${i}`];
                    if (imageUrl) {
                        this.imageUrls.push(imageUrl);
                    }
                }
            },

            async preloadImages() {
                if (this.imagesLoaded || this.imagesLoading || this.imageUrls.length === 0) {
                    return;
                }

                this.imagesLoading = true;
                this.preloadedImages = [];

                try {
                    // Párhuzamosan töltjük be az összes képet
                    const imagePromises = this.imageUrls.map((url) => {
                        return new Promise((resolve, reject) => {
                            const img = new Image();
                            img.onload = () => resolve(img);
                            img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
                            img.src = url;
                        });
                    });

                    // Várjuk meg, hogy az összes kép betöltődjön
                    const loadedImages = await Promise.all(imagePromises);
                    this.preloadedImages = loadedImages;
                    this.imagesLoaded = true;

                    console.log('All gallery images preloaded:', this.preloadedImages.length);
                } catch (error) {
                    console.error('Failed to preload some images:', error);
                    // Részlegesen sikeres betöltés esetén is folytatjuk
                    this.imagesLoaded = true;
                } finally {
                    this.imagesLoading = false;
                }
            },

            async startSlideshow() {
                if (!this.hasGallery || this.imageUrls.length <= 1) return;

                this.isHovering = true;

                // Képek preloadolása ha még nincsenek betöltve
                if (!this.imagesLoaded) {
                    await this.preloadImages();
                }

                // Ha nincs elegendő kép, ne indítsuk el az animációt
                if (this.preloadedImages.length <= 1) {
                    this.isHovering = false;
                    return;
                }

                // Slideshow indítása - MINDIG az első képtől
                // this.currentImageIndex = 0;

                this.slideshowInterval = setInterval(() => {
                    this.nextImage();
                }, this.delay);
            },

            stopSlideshow() {
                this.isHovering = false;

                if (this.slideshowInterval) {
                    clearInterval(this.slideshowInterval);
                    this.slideshowInterval = null;
                }

                // setTimeout(() => {
                //     this.currentImageIndex = 0;
                // }, this.delay);
            },

            nextImage() {
                if (this.preloadedImages.length === 0) return;

                this.currentImageIndex = (this.currentImageIndex + 1) % this.preloadedImages.length;
            },

            decreaseQuantity() {
                if (this.quantity > this.minQuantity) {
                    this.quantity--;
                }
            },

            increaseQuantity() {
                if (this.quantity < this.maxQuantity) {
                    this.quantity++;
                }
            },

            updateQuantity(value) {
                const num = parseInt(value);
                if (!isNaN(num)) {
                    if (num < this.minQuantity) {
                        this.quantity = this.minQuantity;
                    } else if (num > this.maxQuantity) {
                        this.quantity = this.maxQuantity;
                    } else {
                        this.quantity = num;
                    }
                }
            },

            async addToCart() {
                if (this.adding) return;

                console.log('Adding to cart:', this.productId, 'qty:', this.quantity);
                this.adding = true;

                try {
                    const response = await fetch(
                        wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
                        {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'X-Requested-With': 'XMLHttpRequest',
                            },
                            body: new URLSearchParams({
                                product_id: this.productId,
                                quantity: this.quantity,
                                action: 'woocommerce_add_to_cart',
                            }),
                        }
                    );

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    console.log('Add to cart response:', data);

                    if (data.error) {
                        console.error('Add to cart error:', data.error);
                        return;
                    }

                    if (data.fragments) {
                        // Fragments update
                        Object.entries(data.fragments).forEach(([selector, html]) => {
                            const elements = document.querySelectorAll(selector);
                            elements.forEach((el) => {
                                el.outerHTML = html;
                            });
                        });

                        // Event dispatch
                        document.body.dispatchEvent(
                            new CustomEvent('added_to_cart', {
                                detail: [data.fragments, data.cart_hash, data],
                            })
                        );

                        console.log('Product added to cart successfully');
                    }

                    // FunnelKit Cart refresh
                    if (window.FKCart && typeof window.FKCart.refresh === 'function') {
                        window.FKCart.refresh();
                    }

                    // Quantity reset
                    this.quantity = this.minQuantity;
                } catch (error) {
                    console.error('Add to cart failed:', error);
                } finally {
                    this.adding = false;
                }
            },
        }));
    }

    if (typeof Alpine !== 'undefined' && Alpine.version) {
        registerProductCard();
    } else {
        document.addEventListener('alpine:init', () => {
            registerProductCard();
        });
    }
})();
